
import { mapState, mapGetters, mapActions } from "vuex";
import acceptenceTime from "~/assets/images/insights/acceptence-time.svg";
import foodPreperation from "~/assets/images/insights/food-preperation.svg";
import itemSalePerHour from "~/assets/images/insights/item-sale-per-hour.svg";
import orderPerHour from "~/assets/images/insights/order-per-hour.svg";
import revenuePerHour from "~/assets/images/insights/revenue-per-hour.svg";
import currencyConverter from "../common/currency-converter.vue";
export default {
  components: { currencyConverter },
  data() {
    return {
      insightTimeout: "",
      insights: [
        {
          id: "avg-acceptance-time",
          data: "avg_acceptance_time_seconds",
          prev: "prev_avg_acceptance_time_seconds",
          unit: "Sec",
          text: "Avg. aceptence time",
          icon: acceptenceTime
        },
        {
          id: "avg-orders",
          data: "avg_orders_per_hour",
          prev: "prev_avg_orders_per_hour",
          unit: "Orders",
          text: "Avg. orders per hour",
          icon: orderPerHour
        },
        {
          id: "avg-revenue",
          data: "avg_revenue_per_hour",
          prev: "prev_avg_revenue_per_hour",
          unit: "",
          text: "Avg. revenue per hour",
          icon: revenuePerHour
        },
        {
          id: "avg-items-sold",
          data: "avg_items_sold_per_hour",
          prev: "prev_avg_items_sold_per_hour",
          unit: "Item",
          text: "Avg. no. item sale per hour",
          icon: itemSalePerHour
        },
        {
          id: "avg-food-preparation-time",
          data: "avg_food_preparation_time_seconds",
          prev: "prev_avg_food_preparation_time_seconds",
          unit: "Min",
          text: "Avg. Food Preperation",
          icon: foodPreperation
        }
      ]
    };
  },
  props: {
    showDetailPageLink: {
      default: true
    }
  },
  created() {
    this.$nuxt.$on("order-filter-changed", this.fetchReportInsight);
  },
  computed: {
    ...mapState("report", ["reportInsights", "reportInsightsLoading"])
  },
  methods: {
    ...mapActions("report", ["getReportInsights"]),
    fetchReportInsight() {
      clearTimeout(this.insightTimeout);
      this.insightTimeout = setTimeout(
        (() => {
          this.getReportInsights({ backgroundLoad: true });
        }).bind(this),
        this.LOAD_ORDERS_DELAY
      );
    }
  },
  beforeDestroy() {
    this.$nuxt.$off("order-filter-changed");
  }
};
